import React, { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useNotifier } from '@cbgms/base/notifier'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { createMessage } from 'app-support/messages/state/actions'
import MessageForm from './Form'
import { ISupportMessage, MessageTemplate, POSTMessageResponse } from '@cbgms/api/modules/messages'
import { EmptyUUID } from '@cbgms/base/utils/uuid'
import { fetchShopId } from 'app-support/stats/utils'

const NewMessage: React.FC<{}> = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const notifier = useNotifier()
  const h = useHistory()

  const initialValues = useMemo(
    () => ({
      UUID: EmptyUUID,
      PublishDate: '',
      EndDate: '',
      Template: MessageTemplate.Default,
      TargetedModules: [],
      Title: '',
      Message: '',
      LocalizedMessages: [],
      ShopIDs: []
    }),
    []
  )

  const onSubmit = async (values: ISupportMessage) => {
    const Formvalues = { ...values }
    const shopId = fetchShopId(Formvalues.ShopIDs)
    Formvalues.ShopIDs = shopId ? [shopId] : []

    const { Data } = (await dispatch(createMessage(Formvalues))) as any as POSTMessageResponse

    return {
      ...values,
      UUID: Data.UUID
    }
  }
  const onSubmitSuccess = (formValues: ISupportMessage) => {
    notifier.success(t('global.successfully_saved'))
    h.push(`/messages/edit/${formValues.UUID}`)
  }

  return <MessageForm initialValues={initialValues} onSubmit={onSubmit} onSubmitSuccess={onSubmitSuccess} />
}

export default NewMessage
